import './FilterModal.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function FilterModal({ isOpen, onClose, selectedSectors, setSelectedSectors, selectedSubsectors, setSelectedSubsectors, selectedCountries, setSelectedCountries, applyFilters }) {

    const [isInputFocused, setIsInputFocused] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentSectorPage, setCurrentSectorPage] = useState('Building');
    const { t: tChat } = useTranslation('chat');

    const sectors = [
        { label: 'Building', value: 'building' },
        { label: 'Environment', value: 'environment' },
        { label: 'Transport', value: 'transport' }
    ];
    const buildingSubsectors = [
        { label: 'Commercial', value: 'commercial' },
        { label: 'Culture', value: 'culture' },
        { label: 'Education', value: 'education' },
        { label: 'Educational', value: 'educational' },
        { label: 'Healthcare', value: 'healthcare' },
        { label: 'Industrial', value: 'industrial' },
        { label: 'Logistics', value: 'logistics' },
        { label: 'Offices', value: 'offices' },
        { label: 'Others', value: 'others' },
        { label: 'Residential', value: 'residential' },
        { label: 'Sport', value: 'sport' },
        { label: 'Urban', value: 'urban' }
    ];

    const environmentSubsectors = [
        { label: 'Dams', value: 'dams' },
        { label: 'Drainage', value: 'drainage' },
        { label: 'Energy', value: 'energy' },
        { label: 'Mining', value: 'mining' },
        { label: 'Natural', value: 'natural' },
        { label: 'Others', value: 'others' },
        { label: 'Social', value: 'social' },
        { label: 'Solid.waste', value: 'solid.waste' },
        { label: 'Wastewater', value: 'wastewater' },
        { label: 'Water.supply', value: 'water.supply' }
    ];

    const transportSubsectors = [
        { label: 'Airports', value: 'airports' },
        { label: 'Others', value: 'others' },
        { label: 'Ports', value: 'ports' },
        { label: 'Rails', value: 'rails' },
        { label: 'Roads', value: 'roads' },
        { label: 'Urban', value: 'urban' }
    ];
    const countries = [
        { 'label': 'CETEST', 'value': 'CETEST' },
        { 'label': 'Synergia', 'value': 'Synergia' },
        { 'label': 'TPF Consultores', 'value': 'TPF Consultores' },
        { 'label': 'TPF Engineering', 'value': 'TPF Engineering' },
        { 'label': 'TPF Engineering PVT', 'value': 'TPF Engineering PVT' },
        { 'label': 'TPF Engenharia', 'value': 'TPF Engenharia' },
        { 'label': 'TPF Ingenierie', 'value': 'TPF Ingenierie' },
        { 'label': 'TPF Ingeniería', 'value': 'TPF Ingeniería' },
        { 'label': 'TPF Romania', 'value': 'TPF Romania' },
        { 'label': 'TPF Sp Z.o.o', 'value': 'TPF Sp Z.o.o' }
    ];

    if (!isOpen) return null;

    // Função para fechar o modal ao clicar fora do conteúdo
    const handleClickOutside = (event) => {
        if (event.target.classList.contains('modal-overlay-filter')) {
            handleCloseModal();
        }
    };

    // Função para fechar o modal e redefinir estados
    const handleCloseModal = () => {
        onClose();
    };

    return (
        <div className='modal-overlay-filter' onClick={handleClickOutside}>
            <div className='modal-content-filter'>
                <p className='filter-title'>{tChat("filters")}</p>

                <img src="/imagens/x-red.svg" alt={tChat("closeButton")} className='close-filter-modal' onClick={handleCloseModal}/>

                <div className='unity-filter'>

                    <p className='filter-subtitle'>{tChat("select_unit")}</p>

                    <input
                        className='input-filter'
                        placeholder={tChat('search_unit')}
                        value={searchTerm}
                        onFocus={() => setIsInputFocused(true)}
                        onBlur={() => setTimeout(() => setIsInputFocused(false), 200)} // pequeno delay para permitir clique
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    {isInputFocused && (
                        <div className="dropdown-filter">
                            {countries
                                .filter(country =>
                                    country.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
                                    !selectedCountries.some(selected => selected.value === country.value)
                                )
                                .map((country, index) => (
                                    <div
                                        key={index}
                                        className="dropdown-item"
                                        onClick={() => {
                                            setSearchTerm(country.label);
                                            const alreadyExists = selectedCountries.some(c => c.value === country.value);
                                            if (!alreadyExists) {
                                                setSelectedCountries(prev => [...prev, { label: country.label, value: country.value }]);
                                            }
                                            setIsInputFocused(false);
                                            setSearchTerm('');
                                        }}
                                    >
                                        {country.label}
                                    </div>
                                ))}
                        </div>
                    )}

                    {selectedCountries.length > 0 && (
                        <div className="selected-countries">
                            {selectedCountries.map((country, index) => (
                                <div key={index} className="country-chip">
                                    {country.label}
                                    <img
                                        src="/imagens/x.svg"
                                        className="remove-chip"
                                        onClick={() =>
                                            setSelectedCountries(prev =>
                                                prev.filter(c => c.value !== country.value)
                                            )
                                        }
                                    />

                                </div>
                            ))}
                        </div>
                    )}

                </div>

                <div className='sector-filter'>

                    <p className='filter-subtitle'>{tChat("select_sector")}</p>

                    <div className="selected-sectors">
                        {sectors.map((sector, index) => {
                            const isSelected = selectedSectors.some(s => s.value === sector.value);
                            return (
                                <div
                                    key={index}
                                    className={`sector-chip ${isSelected ? 'activated' : ''}`}
                                    onClick={() => {
                                        const sectorValue = sector.value;
                                        const sectorLabel = sector.label;

                                        if (!isSelected) {
                                            setSelectedSectors(prev => [...prev, { label: sectorLabel, value: sectorValue }]);
                                        } else {
                                            // Remove o setor e limpa os subsetores associados
                                            setSelectedSectors(prev => prev.filter(s => s.value !== sectorValue));
                                            setSelectedSubsectors(prev => ({
                                                ...prev,
                                                [sectorValue]: [] // Limpa os subsetores daquele setor
                                            }));
                                        }
                                    }}
                                >
                                    {sector.label}
                                </div>
                            );
                        })}
                    </div>

                </div>

                <div className='subsector-filter'>
                    <p className='filter-subtitle'>{tChat("select_subsector")}</p>

                    <div className="subsector-carousel-wrapper">
                        <button
                            className="carousel-arrow"
                            onClick={() => {
                                const currentIndex = sectors.findIndex(sec => sec.label === currentSectorPage);
                                if (currentIndex > 0) {
                                    setCurrentSectorPage(sectors[currentIndex - 1].label);
                                }
                            }}
                        >
                            <img src="/imagens/left-arrow-black.svg" alt={tChat("previousButton")}/>
                        </button>

                        <div className="carousel-sector-label">{currentSectorPage}</div>

                        <button
                            className="carousel-arrow"
                            onClick={() => {
                                const currentIndex = sectors.findIndex(sec => sec.label === currentSectorPage);
                                if (currentIndex < sectors.length - 1) {
                                    setCurrentSectorPage(sectors[currentIndex + 1].label);
                                }
                            }}
                        >
                            <img src="/imagens/right-arrow-black.svg" alt={tChat("nextButton")}/>
                        </button>
                    </div>

                    <div className='scroll-subsector'>
                        {[
                            { title: 'Building', data: buildingSubsectors },
                            { title: 'Environment', data: environmentSubsectors },
                            { title: 'Transport', data: transportSubsectors }
                        ]
                            .filter(group => group.title === currentSectorPage)
                            .map((group, index) => {
                                const sectorKey = group.title.toLowerCase();
                                const sectorIsActive = selectedSectors.some(s => s.label === group.title);
                                const disableSubsectors = !sectorIsActive;

                                return (
                                    <div key={index} className='subsector-grid'>
                                        {group.data.map((subsector, i) => {
                                            const isSelected = selectedSubsectors[sectorKey].includes(subsector.value);

                                            return (
                                                <div
                                                    key={i}
                                                    className={`sector-chip ${isSelected ? 'activated' : ''}`}
                                                    style={{
                                                        color: disableSubsectors ? '#5B5D6E' : undefined,
                                                        cursor: disableSubsectors ? 'not-allowed' : 'pointer'
                                                    }}
                                                    onClick={() => {
                                                        if (disableSubsectors) return;
                                                        setSelectedSubsectors(prev => {
                                                            const updatedList = isSelected
                                                                ? prev[sectorKey].filter(val => val !== subsector.value)
                                                                : [...prev[sectorKey], subsector.value];

                                                            return {
                                                                ...prev,
                                                                [sectorKey]: updatedList
                                                            };
                                                        });
                                                    }}
                                                >
                                                    {subsector.label}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}

                    </div>

                </div>

                <div className='central-button'>
                    <button className='gray-button'
                        onClick={() => {
                            applyFilters();
                            onClose(); // Fecha o modal após aplicar o filtro
                        }}>
                        {tChat("filter")}
                    </button>
                </div>

            </div>
        </div>
    );
}

export default FilterModal;